// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function Price(props) {
  let size = props.size;
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: TailwindMerge.twMerge([
      "text-tan-gold",
      size !== undefined ? (
          size === "medium" ? "text-2xl font-medium" : (
              size === "small" ? "text-xl font-semibold" : "text-3xl font-medium"
            )
        ) : "text-2xl font-medium sm:text-3xl",
      Stdlib_Option.getOr(props.className, "")
    ])
  });
}

let make = Price;

exports.make = make;
/* tailwind-merge Not a pure module */
